import { CustomTooltip } from "@shared/components/CustomTooltip";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Activity } from "lucide-react";
import React from "react";

interface KeyStatsCardProps {
  data: {
    totalMeters: number;
    collectedReadings: number;
    missingReadings: number;
    dispatchedRoutes: number;
    totalRoutes: number;
  };
}

export const KeyStatsCard: React.FC<KeyStatsCardProps> = ({ data }) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <Activity className="h-5 w-5 text-green-600" />
          <CardTitle className="text-lg font-semibold">Key Stats</CardTitle>
        </div>
        <p className="text-sm text-gray-600">
          Performance indicators and health metrics
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
            <span className="text-sm text-gray-600">Total Meters</span>
            <CustomTooltip message="Total meters included in this cycle scope." />
          </div>
          <span>{data?.totalMeters ?? "NA"}</span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
            <span className="text-sm text-gray-600">Collected Readings</span>
            <CustomTooltip message="Number of readings submitted so far in this cycle." />
          </div>
          <div className="text-right">
            <span>
              {data?.collectedReadings ?? "0"}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
            <span className="text-sm text-gray-600">Missing Readings</span>
            <CustomTooltip message="Count of readings not captured yet. Use estimation if needed." />
          </div>
          <div className="text-right">
            <span>
              {data?.missingReadings ?? 0}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
            <span className="text-sm text-gray-600">Dispatched / Total Routes</span>
            <CustomTooltip message="Routes assigned to readers vs total routes in this cycle." />
          </div>
          <span className="">
            {data?.dispatchedRoutes ?? 0} / {data?.totalRoutes ?? 0}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
